import React from "react";
import PropTypes from "prop-types";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { PORTAL_PURCHASE } from "MODULES/Lots/constants";
import Form from "./Form";

export default function EditVendor({ open, close, lot }) {
  const initialValues = {
    ...lot,
    contact: null,
    company_id: lot.company && lot.company.id,
    contact_id: lot.portal_purchase
      ? PORTAL_PURCHASE
      : lot.contact && lot.contact.id
  };

  return (
    <Modal open={open} close={close}>
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Edit Vendor Details</h4>
      </Header>
      <Form
        close={close}
        initialValues={initialValues}
        lot={lot}
        enableReinitialize
      />
    </Modal>
  );
}

EditVendor.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  lot: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/Lots/Detail/Edit/EditVendor/EditVendor.jsx